import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import styled from "styled-components";
import { PlateElement, type PlateElementProps } from "@platejs/core/react";
import { css } from "styled-components";
interface HeadingElementProps extends PlateElementProps {
  variant?: "h1" | "h2" | "h3";
}
export const HeadingElement: FC<HeadingElementProps> = t0 => {
  const $ = _c(11);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "h1" : t1;
  const {
    element,
    editor
  } = props;
  const t2 = element.type === "h1" && element.children[0]?.text === editor.children[0]?.text;
  let t3;
  if ($[4] !== children || $[5] !== t2 || $[6] !== variant) {
    t3 = <StyledHeading as={variant} $isFirstBlock={t2}>{children}</StyledHeading>;
    $[4] = children;
    $[5] = t2;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== t3) {
    t4 = <PlateElement {...props}>{t3}</PlateElement>;
    $[8] = props;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
const h1 = css`
	font-size: 1.5em;
	font-weight: 500;
	line-height: 1.3;
	margin: 0.75em 0 2px;

	@media screen and (min-width: 768px) {
		font-size: 1.875em;
		margin: 1em 0 2px;
	}
`;
const h2 = css`
	font-size: 1.25em;
	font-weight: 500;
	line-height: 1.3;
	margin: 0.6em 0 0.5px;

	@media screen and (min-width: 768px) {
		font-size: 1.5em;
		margin: 0.7em 0 0.5px;
	}
`;
const StyledHeading = styled.h1<{
  $isFirstBlock: boolean;
}>`
	${({
  as
}) => {
  switch (as) {
    case "h1":
      return h1;
    case "h2":
      return h2;
    case "h3":
      return `
					color: #434343;
          font-size: 1.125em;
          font-weight: 500;
          line-height: 1.3;
					margin: 0.4375em 0 0.5px;

					@media screen and (min-width: 768px) {
						font-size: 1.25em;
						margin: 0.5em 0 0.5px;
					}
				`;
    case "h4":
      return `
						color: #666;
						font-size: 1em;
						font-weight: 500;
						line-height: 1.3;
						margin: 0.625em 0 0;

						@media screen and (min-width: 768px) {
							font-size: 1.1em;
							margin: 0.75em 0 0;
						}
					`;
    case "h5":
      return `
					color: #666;
          font-size: 1em;
          font-weight: 500;
          line-height: 1.3;
					margin: 0.3125em 0 0;

					@media screen and (min-width: 768px) {
						font-size: 1.1em;
						margin: 0.375em 0 0;
					}
				`;
    case "h6":
      return `
					color: #666;
					font-size: 1em;
					font-weight: 500;
					line-height: 1.3;
					margin: 0.3125em 0 0;

					@media screen and (min-width: 768px) {
						font-size: 1.1em;
						margin: 0.375em 0 0;
					}
				`;
    default:
      throw new Error("Invalid tag");
  }
}}
	${({
  $isFirstBlock
}) => $isFirstBlock && "margin-top: 0;"}	
`;